import PropTypes from 'prop-types';

import { Collapsible } from '../common/collapsible';

import { DynamicIcon } from 'components/common/dynamicIcon';

export const WhyBookDirectlySection = ({ title, benefits = [] }) => {
    return (
        benefits.length > 0 && (
            <div className="ab-body-sidebar-section">
                <Collapsible open title={title}>
                    <div
                        className="ab-section-body"
                        style={{ paddingBottom: '40px' }}
                    >
                        {benefits.map((benefit, index) => {
                            return (
                                <div className="ab-wbd-row" key={index}>
                                    <label className="ab-checkmark-container">
                                        <span className="ab-icon-appeal">
                                            <DynamicIcon
                                                name={benefit.appealIcon}
                                                size={20}
                                            />
                                        </span>
                                        <span style={{ display: 'flex' }}>
                                            {benefit.appealOption}
                                        </span>
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                </Collapsible>
            </div>
        )
    );
};

WhyBookDirectlySection.propTypes = {
    title: PropTypes.string,
    benefits: PropTypes.array,
};
